import React, { FC } from 'react'
import styled from 'styled-components'

import { IconBar } from '@Components/Header/IconBar'
import { NavBar } from '@Components/Header/NavBar'
import { up } from '@Globals/Style/breakpoints'

interface MenuProps {
  blocked: boolean
  onBackdropChange: (isOpen: boolean) => void
}

const Wrapper = styled.div`
  ${up('desktop')} {
    display: none;
  }
`

export const Menu: FC<MenuProps> = (
  {
    blocked,
    onBackdropChange,
  }: MenuProps,
) => (
  <div>
    {/* Desktop */}
    <NavBar
      blocked={blocked}
      onBackdropChange={onBackdropChange}
    />

    {/* Mobile */}
    <Wrapper>
      <IconBar />
    </Wrapper>
  </div>
)
